module.exports = __webpack_public_path__ + "static/img/game-logo-ag.0fe0a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-ag.png
// module id = hyqD
// module chunks = 0 1 2 3 4 5 6